<template>
  <router-view />
</template>

<script>
export default {
  watch: {
    '$route.hash': function () {
      if (this.$route.hash) {
        this.scrollToSection(this.$route.hash);
      } else {
        document.querySelector('.app-wrapper').scrollTo(0, 0);
      }
    },
  },
  methods: {
    scrollToSection(selector) {
      const element = document.querySelector(selector);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    },
  },
};
</script>

<style lang="scss">
.settings-page {
  &-view {
    width: 100%;
    max-width: 1200px;

    @include respond-to('large') {
      width: 100%;
      min-width: auto !important;

      .responsive-hide {
        display: none !important;
      }
    }
  }

  .i-section-divide:first-of-type {
    border-top: none;
  }

  .settings-page-block {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    @include respond-to('medium') {
      flex-direction: column;
      justify-content: flex-start;

      .settings-page-block-title {
        padding-right: 0;
        padding-bottom: 32px;
      }
    }

    .settings-page-block-title {
      width: 100%;
      padding-right: 64px;
    }

    .settings-page-block-content {
      width: 100%;
      max-width: 650px;
    }
  }
}
</style>
